interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  fullScreen?: boolean
  label?: string
  variant?: 'default' | 'ios' | 'dots'
}

export default function LoadingSpinner({
  size = 'md',
  fullScreen = false,
  label,
  variant = 'default'
}: LoadingSpinnerProps) {
  const sizeMap = {
    sm: { spinner: 'spinner-native sm', dots: 'w-1.5 h-1.5', text: 'text-xs' },
    md: { spinner: 'spinner-native', dots: 'w-2 h-2', text: 'text-sm' },
    lg: { spinner: 'spinner-native lg', dots: 'w-3 h-3', text: 'text-base' }
  }

  const renderSpinner = () => {
    switch (variant) {
      case 'ios':
        return (
          <div className={`spinner-ios ${size === 'sm' ? 'scale-75' : size === 'lg' ? 'scale-150' : ''}`} />
        )

      case 'dots':
        return (
          <div className="flex items-center gap-1">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className={`${sizeMap[size].dots} rounded-full bg-indigo-500`}
                style={{
                  animation: 'pulse-soft 1s ease-in-out infinite',
                  animationDelay: `${i * 0.15}s`
                }}
              />
            ))}
          </div>
        )

      default:
        return <div className={sizeMap[size].spinner} />
    }
  }

  const spinner = (
    <div className="flex flex-col items-center justify-center gap-3">
      {renderSpinner()}
      {label && (
        <p className={`${sizeMap[size].text} text-gray-600 animate-pulse-soft`}>
          {label}
        </p>
      )}
    </div>
  )

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-50/80 backdrop-blur-sm z-50 animate-fade-slide-in">
        {spinner}
      </div>
    )
  }

  return spinner
}
